import { HP_SET_ENV } from '../Types';

export const HPSetEnv = ({ env }) => ({
	type: HP_SET_ENV,
	payload: {
		env
	},
});
